import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropdown from 'react-dropdown';
import { 
  Table, 
  Form, 
  FormControl, 
  Button, 
  Alert, 
  Col, 
  Popover, 
  OverlayTrigger 
} from 'react-bootstrap';
import { 
  addPortfolioUser, 
  addUserError, 
  removePortfolioUser 
} from '../../../actions';

const dropdownOptions = [
  { label: 'Full Access', value: 2 },
  { label: 'Readonly', value: 3 }
];

class UserAccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      privilege: null,
    };
  }

  removeUserAccessPopover = (portfolioUserId, user_id) => (
    <Popover id="remove-access-popover" title="Remove user access?">
      <Button 
        className="popover-cancel"
        bsStyle="default"
        onClick={() => document.body.click()}>Cancel</Button>
      <Button
        bsStyle="primary"
        className="btn-blue popover-confirm"
        onClick={() => this.props.removePortfolioUser({ portfolioUserId, user_id })}>Confirm</Button>
    </Popover>
  );

  mapUsers = () => {
    return this.props.session.activePortfolioUserList.map((item, index) => {
      return (
        <tr key={item.id}>
          <td>{index + 1}</td>
          <td>{item.email}</td>
          <td>{item.privilege}</td>
          { item.privilege !== 'owner' ?
          <td className="remove-user">
            <OverlayTrigger trigger="click" rootClose placement="top" overlay={this.removeUserAccessPopover(item.id, item.user_id)}>
              <Button  
                disabled={ item.email === this.props.session.currentUser ? true : false }>
                x
              </Button>
            </OverlayTrigger>
          </td> 
          : <td className="remove-user"></td> }
        </tr>
      );
    });
  }

  mapUsersReadonly = () => {
    return this.props.session.activePortfolioUserList.map((item, index) => {
       return (
         <tr key={item.id}>
           <td>{index + 1}</td>
           <td>{item.email}</td>
           <td>{item.privilege}</td>
         </tr>
       );
     });
   }

  onAddPortfolioUser = (e) => {
    e.preventDefault();    
    const { privilege, email } = this.state;
    if (!privilege || !email) {
      this.props.addUserError('Please fill out all fields.');
    } else {
      this.props.addPortfolioUser({
        email: email,
        userPrivilege: privilege.value,
        activePortfolioId: this.props.session.activePortfolioUser.portfolio_id
      });
    }
  }

  renderAlert = () => {
    if (this.props.session.addUserError) {
      return (
        <Alert bsStyle="danger" style={{ marginBottom: 15 }}>
          <strong>Oops!</strong> {this.props.session.addUserError}
        </Alert>
      );
    }
  }

  render() {

    if (this.props.session.activePortfolioUser.privilege === 'readonly') {
      return (
        <Table bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Email</th>
            <th>Privilege</th>
          </tr>
        </thead>
        <tbody>
          {this.mapUsersReadonly()}
        </tbody>
      </Table>
      );
    }

    return (
      <div>
        <Form onSubmit={this.onAddPortfolioUser} id="add-user">
          <Col sm={12} md={5}>
            <FormControl 
              type="email" 
              className="user-email"
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.target.value })}
              placeholder="Enter user's email" />
          </Col>
          <Col sm={12} md={5}>
            <Dropdown     
              options={dropdownOptions}
              value={this.state.privilege}
              onChange={(option) => this.setState({ privilege: option })} />
          </Col>
          <Col sm={12} md={2}>
            <Button
              bsStyle="primary" 
              className="btn-blue add-user-btn"
              type="submit"
            >Add</Button>
          </Col>
        </Form> 

        {this.renderAlert()}

        <Table bordered hover responsive className="user-access-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Email</th>
              <th>Privilege</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {this.mapUsers()}
          </tbody>
        </Table>
      </div>
    );
  }
}

function mapStateToProps({ session }) {
  return {
    session
  };
}

export default connect(mapStateToProps, { 
  addPortfolioUser, 
  addUserError, 
  removePortfolioUser 
})(UserAccess);